<div class="card">
    <div class="card-block">
        <div *ngIf="successMessage" class="alert alert-success" role="alert">
            <span class="fas fa-exclamation-circle mr-1" aria-hidden="true"></span>{{ successMessage | translate }}
        </div>
        <div class="notifications-details" *ngIf="selectedNotification" [class.hasRead]="selectedNotification.title">
            <div *ngIf="displayMsg" class="row alert alert-warning">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
                <span [innerHTML]="displayContent | translate: displayParams"></span>
            </div>
            <div class="row">
                <div class="col-xs-11">
                    <h2 class="notifications-details__title"
                        [innerHTML]="selectedNotification.title | translate: selectedNotification.params">
                    </h2>
                </div>
                <div class="col-xs-1 text-xs-right">
                    <button class="btn btn-link" [title]="'Delete' | translate" (click)="deleteNotification()">
                        <i class="far fa-trash-alt notifications-details__delete-icon"></i>
                    </button>
                </div>
            </div>

            <div class="notifications-details__date pb-1">
                <span [innerHTML]="selectedNotification?.displayTime | dateDiffTranslate"></span>
            </div>

            <div class="actions pt-1 pb-1" *ngIf="selectedNotification?.isTransferRequest && !isRemoveAction">
                <div class="actions__item transfer" *ngIf="!selectedNotification?.isActive">
                    <div *ngIf="selectedNotification?.isAccepted">
                        <i class="mr-0 transfer-submitted accepted text-secondary fas fa-check-circle"></i>
                        <span>
                            {{ 'Request was accepted at' | translate }} {{ selectedNotification.respondedAt | dateDiffTranslate }}
                        </span>
                    </div>
                    <div *ngIf="selectedNotification?.isDelinced">
                        <i class="mr-0 transfer-submitted denied fas fa-times-circle text-danger"></i>
                        <span>
                            {{ 'Request was declined at' | translate }} {{ selectedNotification.respondedAt | dateDiffTranslate }}
                        </span>
                    </div>
                </div>
                <div class="actions__item transfer" *ngIf="selectedNotification?.isActive && !selectedNotification?.isCancel">
                    <button class="btn btn-link" (click)="acceptTransfer()">
                        <i class="transfer-submitted accepted text-secondary fas fa-check-circle"></i>
                        <span>{{ 'Accept' | translate }}</span>
                    </button>
                    <button class="btn btn-link" (click)="denyTransfer()">
                        <i class="ml-3 transfer-submitted denied fas fa-times-circle text-danger"></i>
                        <span>{{ 'Decline' | translate }}</span>
                    </button>
                </div>
                <div class="actions__item default" *ngIf="selectedNotification.hasDefaultAction && selectedNotification?.isTransferRequest">
                    <button class="btn btn-link text-right goto-action" (click)="doDefaultAction()">
                        <strong>
                            <i class="fas fa-long-arrow-alt-right"></i>
                        </strong>
                        <span>{{ selectedNotification?.defaultActionLabel | translate }}</span>
                    </button>
                </div>
            </div>

            <div class="notifications-details__message" *ngIf="selectedNotification"
                 [innerHTML]="selectedNotification.template | translate: selectedNotification.params"></div>

            <div class="notifications-details__transfer" *ngIf="selectedNotification?.isTransferRequest && !isRemoveAction">
                <div class="row pb-1">
                    <div class="col-xs-6">{{ selectedNotification?.doctorName }}</div>
                    <div class="col-xs-6">
                        <a class="text-muted" href="tel:{{selectedNotification?.doctorPhone}}">
                            {{ selectedNotification?.doctorPhone }}
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-6 text-muted">
                        {{ selectedNotification?.clinicName }}
                    </div>
                    <div class="col-xs-6">
                        <a class="text-muted" href="mailto:{{ selectedNotification?.doctorEmail }}">
                            {{ selectedNotification?.doctorEmail }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="pt-1" *ngIf="selectedNotification
                                    && (selectedNotification?.isTransferType || selectedNotification?.isAssignmentType)
                                    && selectedNotification.assignmentNote">
                <h3 class="notifications-details__sub-title">{{ 'Doctor\'s Note' | translate }}:</h3>

                <div class="notifications-details__note" [innerHTML]="selectedNotification.assignmentNote | translate">
                </div>
            </div>

            <div class="actions pt-1 pb-2" *ngIf=" !isRemoveAction">
                <div class="actions__item transfer"></div>
                <div class="actions__item default" *ngIf="selectedNotification.hasDefaultAction && !selectedNotification?.isTransferRequest">
                    <button class="btn btn-link goto-action" (click)="doDefaultAction()">
                        <i class="fas fa-long-arrow-alt-right goto-action__icon"></i>
                        <span>{{ selectedNotification?.defaultActionLabel | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<dialog-component #dialog></dialog-component>
